/**
 * Destination URLs for the "Raise it with Bevan" CTAs.
 *
 * Two separate links so analytics can distinguish header vs footer clicks
 * (UTM `content` differs). Swap these for the Bitly short links once minted:
 *   - Bitly UTM values: source=warrenblackwood_site, medium=button,
 *     campaign=raise_it_with_bevan, content=header | footer
 */
export const RAISE_IT_HEADER_URL = 'https://link.bevaneatts.com.au/4wv57uJ';
export const RAISE_IT_FOOTER_URL = 'https://link.bevaneatts.com.au/3SPdOS3';
